import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=665a6af0&scoped=true"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"
import style0 from "@/styles/styled_cell.less?vue&type=style&index=0&id=665a6af0&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665a6af0",
  null
  
)

export default component.exports